
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import InstaImage from "@src/components/InstaImage";
import ShopInfoBox from "@src/components/ShopInfoBox";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuCrisscrossMorningCrisscrossMorningImage } from "@src/constants/images";
import { meta as crisscrossPageMeta } from "./crisscross.mdx";
export const meta = {
  path: "/media/harajuku/crisscross_morning",
  title: "【絶品】モーニングの名店「クリスクロス 」で最高の朝を",
  description: "モーニングが有名なことで知られる「クリスクロス 」についてご紹介します。お店の概要、テラス席、行列情報、モーニングメニューについて気になる情報を記載しております。モーニングをクリスクロスで検討している方には必見の内容になっているので、ぜひご一読ください。",
  topImg: harajukuCrisscrossMorningCrisscrossMorningImage,
  author: murakamiMasanori,
  tags: ["表参道", "有名店", "おしゃれな内装", "スイーツ", "人気店", "お店の紹介", "パンケーキ", "朝食", "インスタ映え"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`モーニングが有名なことで知られる「クリスクロス 」についてご紹介します。`}</p>
    <p>{`お店の概要、開放的なテラス席の写真をシーンに分けて掲載、行列情報からわかる狙い目の時間帯、多種類のモーニングメニューを写真付きで、掲載。モーニングをクリスクロスで検討している方には必見の内容になっているので、ぜひご一読ください。`}</p>
    <h2>{`クリスクロスとは`}</h2>
    <p>{`原宿から徒歩 10 分ほど歩いたところに位置するお店で、パンケーキをはじめとした多彩な料理が食べられるおしゃれなお店として知られています。
特にモーニングは行列ができることもあるほど人気で、モーニングのパンケーキメニューを求めて、連日いろんなお客様が来店されています。`}</p>
    <p>{`そんなクリスクロスのモーニングに関する情報を、テラス、行列、メニューの３つの観点からご紹介します。`}</p>
    <h2>{`モーニングにぴったりのテラス`}</h2>
    <InstaImage postId="B_t9bV5D-dt" mdxType="InstaImage" />
    <p>{`テラスに入る入り口の部分には、自転車などがインテリアとして備え付けられており、ここで思わず写真を撮りたくなってしまうような風景。`}</p>
    <InstaImage postId="B_qx5udAucY" mdxType="InstaImage" />
    <p>{`広々としたエリアにはクリスクロス 以外にも人気のお店が入っていて、テラス席から別のお店を覗くこともできるようになっています。`}</p>
    <InstaImage postId="B9CF69OhPCQ" mdxType="InstaImage" />
    <p>{`テラス席はこのような作りになっており、広々とした空間でモーニングを堪能できます。
ペットも同伴することができるので、ペットを作れて散歩がてらにモーニングは普段できない体験。`}</p>
    <InstaImage postId="B8aKo3mFwEf" mdxType="InstaImage" />
    <p>{`テラス席からから空を見上げると木々と綺麗な青空が広がっていて開放的な雰囲気で、冬の時期にはガスストーブがつくので、季節を問わずに安心してモーニングができるのが特徴的。`}</p>
    <InstaImage postId="B6pfwQJjxvu" mdxType="InstaImage" />
    <p>{`夕方になるとデートにぴったりな雰囲気になるので、モーニングだけでなく夜もテラスで食事を楽しむことができます。`}</p>
    <hr></hr>
    <h2>{`モーニングの行列情報`}</h2>
    <p>{`クリスクロスでは朝の 8 時から営業を開始しているのですが、モーニングでも遅い時間帯だと行列ができてしまうことがあります。
特に休日の 10 時頃は遅めのモーニングになるので、行列ができやすい時間帯です。`}</p>
    <p>{`狙い目は朝のオープンから 9 時半までの時間帯にはモーニングで訪れるのが理想的です。
朝から行列に並ぶのはストレスが溜まりやすいと思うので、ぜひ狙い目の時間帯に足を運んでみてください。`}</p>
    <hr></hr>
    <h2>{`モーニングメニュー`}</h2>
    <h3>{`バターミルクパンケーキ ソーセージ、フライドエッグ`}</h3>
    <InstaImage postId="B4BS216JE0c" mdxType="InstaImage" />
    <p>{`クリスクロスのモーニングメニューといえば、このパンケーキが 1 番人気。
もちもちのパンケーキと、クリスクロスが自家製で作る大きなソーセージが特徴的になっています。`}</p>
    <p>{`朝からガッツリのメニューになりますが、甘いパンケーキと塩気のあるソーセージ・フライドエッグがバランスを保っており、飽きずに食べられるメニューとなっています。
初めてクリスクロスにお越しの方には、ぜひ食べてもらいたいモーニングメニューです。`}</p>
    <h3>{`エッグベネディクト`}</h3>
    <InstaImage postId="CCTAg5KgVCW" mdxType="InstaImage" />
    <p>{`モーニングといえば、海外旅行などでもエッグベネディクトを食べたくなる方も多いのではないでしょうか。
クリスクロス にもモーニングメニューとして存在し、ふわふわのポーチドエッグが胡椒、サーモン、サラダと織りなす味に虜になってしまいます。`}</p>
    <p>{`こちらもモーニング好きにはオススメしたい一品です。`}</p>
    <h3>{`フレンチトースト`}</h3>
    <InstaImage postId="CBfQ4ljgyyf" mdxType="InstaImage" />
    <p>{`パンケーキは苦手だけどフレンチトーストなら食べたいという方が中にはいらっしゃるのではないかと思います。
パンケーキのもちもちとは異なり、フワッとした食感のフレンチトーストは、甘さが凝縮されていて、食べた瞬間に甘い風味が広がるような一品になっています。`}</p>
    <h3>{`ケールとカリフラワーライスのヴィーガンサラダ`}</h3>
    <InstaImage postId="CCAkAJJjI8y" mdxType="InstaImage" />
    <p>{`健康志向の方や野菜中心の食生活をされている方には、こちらのサラダがオススメ！
ヴィーガンサラダになっているので、お肉などは一切使用しておらず、野菜の旨味を厳選したメニューになっています。`}</p>
    <p>{`モーニングからサラダを食べて、体にビタミンを届けて、健康的な 1 日を過ごすことができると思います。`}</p>
    <LinkWithThumbnail meta={crisscrossPageMeta} mdxType="LinkWithThumbnail" />
    <ShopInfoBox shopId="bs08n7a23akg0088jkp0" mdxType="ShopInfoBox" />
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`クリスクロス のテラス席、行列、モーニングメニューについてご紹介してきましたが、いかがでしたか。
モーニングとして人気のお店は東京でも数少なく、パンケーキをはじめとして豊富な種類がたくさんあるのがクリスクロス の魅力で、行列ができるようになっているのでしょう。`}</p>
    <p>{`東京にお越しの方でモーニングを検討している方や、原宿エリアでモーニングがしたい方は、ぜひクリスク鳥栖にお越しいただければと思います！`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;